module.exports = __webpack_public_path__ + "assets/fonts/AdelleSans-Light.otf";